module.exports = __webpack_public_path__ + "img/album18_51.b15cd52b.jpg";